import { Component } from '@angular/core';
import { SearchableEntityServiceFactory } from '../../../../../shared/services/searchable-entity/searchable-entity-service-factory';
import { ReportsConfigurationButtonService } from '../../services/reports-configuration-button.service';
import { ReportsConfigurationActionService } from '../../services/reports-configuration-action.service';
import { ReportsConfigurationBackendService } from '../../services/reports-configuration-backend.service';
import { ReportsConfigurationDataService } from '../../services/reports-configuration-data.service';
import { ReportsConfigurationDataEditorService } from '../../services/reports-configuration-data-editor.service';

@Component({
  selector: 'lfwms-reports-configuration-search',
  templateUrl: './reports-configuration-search.component.html',
  styleUrls: ['./reports-configuration-search.component.css']
})
export class ReportsConfigurationSearchComponent {

  public serviceFactory: SearchableEntityServiceFactory;

  constructor(protected dataService: ReportsConfigurationDataService, protected actionService: ReportsConfigurationActionService,
    protected buttonService: ReportsConfigurationButtonService, protected dataEditor: ReportsConfigurationDataEditorService,
     protected backendService: ReportsConfigurationBackendService) {
    this.serviceFactory = new SearchableEntityServiceFactory(dataService, actionService, backendService, dataEditor, buttonService);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-search/reports-configuration-search.component.ts